<template>
    <v-row no-gutters>
      <v-col class="pa-3">
        <div v-if="return_create_race" class="text-right">
          <v-btn @click="link()">
            {{ $t("page.eventClasses.back-to-create-race") }} 
          </v-btn>
        </div>
        <v-card elevation="2">
          <v-card-title class="accent text-customizer-exp">{{ titlePage }}</v-card-title>
          <v-card-text>
            <v-form ref="formClasses" v-model="valid" class="width-lg">
              <v-container>

                <v-row class="field-sm-c" >
                  <v-col cols="10">
                    <v-text-field
                      id="name"
                      hide-details="auto"
                      :label="$t('page.eventClasses.class-name')"
                      :rules="[rules.name.validate.required]"
                      v-model="name"
                      style="margin: 10px 0"
                      outlined
                      dense
                      :placeholder="$t('page.eventClasses.placeholder.class-name')"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-text-field
                      id="sort"
                      hide-details="auto"
                      :label="$t('page.eventClasses.sort-order')"
                      type="number"
                      :rules="[rules.sort.validate.valid]"
                      v-model="sort"
                      style="margin: 10px 0"
                      outlined
                      dense
                      :placeholder="$t('page.eventClasses.placeholder.sort')"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-text-field
                      id="row-limit"
                      hide-details="auto"
                      :label="$t('page.eventClasses.row-limit')"
                      :rules="[rules.rowLimit.validate.valid]"
                      v-model="rowLimit"
                      style="margin: 10px 0"
                      outlined
                      dense
                      :placeholder="$t('page.eventClasses.placeholder.row-limit')"
                      :hint="$t('page.eventClasses.msg-row-limit')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-text-field
                    id="reserved-position"
                      hide-details="auto"
                      :label="$t('page.eventClasses.reserved-position')"
                      :rules="[rules.reserved.validate.valid]"
                      v-model="reserved"
                      style="margin: 10px 0"
                      outlined
                      dense
                      :placeholder="$t('page.eventClasses.placeholder.reserved-position')"
                      :hint="$t('page.eventClasses.msg-reserved-positions')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-alert type="info" dense text class="mt-2 mb-0">
                      {{ $t('page.eventClasses.dynamic-pricing-note') }}
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-text-field
                    id="group"
                      hide-details="auto"
                      :label="$t('page.eventClasses.group')"
                      :rules="[rules.group.validate.valid]"
                      v-model="group"
                      style="margin: 10px 0"
                      outlined
                      dense
                      :placeholder="$t('page.eventClasses.placeholder.group')"
                      :hint="$t('page.eventClasses.msg-group')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('page.eventClasses.start-row')"
                      type="number"
                      :rules="[rules.startRow.validate.valid]"
                      v-model="startRow"
                      style="margin: 10px 0"
                      outlined
                      dense
                      :placeholder="$t('page.eventClasses.placeholder.start-row')"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-menu ref="startTime" v-model="menu['startTime']" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          :label="$t('page.eventClasses.start-time')"
                          v-model="startTime"
                          style="margin: 10px 0"
                          append-icon="fa-clock"
                          v-bind="attrs" 
                          v-on="on"
                          outlined
                          readonly
                          dense
                          :placeholder="$t('page.eventClasses.placeholder.start-time')"
                          :hint="$t('page.eventClasses.msg-start-time')"
                          persistent-hint
                        ></v-text-field>
                      </template>

                      <v-card height="auto" width="340" style="padding: 2%" class="text-input-date">
                        <div>
                          <v-time-picker
                            v-if="menu['startTime']"
                            v-model="startTime"
                            :color="navigationBGColor"
                            :header-color="navigationBGColor"
                            format="24hr"
                            use-seconds
                            @click:second="$refs.startTime.save(startTime)"
                          >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="$refs.startTime.save(startTime)">
                            OK
                          </v-btn>
                          </v-time-picker>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c" >
                  <v-col cols="10">
                    <v-menu v-model="menu['raceLength']" ref="raceLength" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          :label="$t('page.eventClasses.race-length')"
                          v-model="raceLength"
                          style="margin: 10px 0"
                          append-icon="fa-clock"
                          v-bind="attrs" 
                          v-on="on"
                          outlined
                          readonly
                          dense
                          :placeholder="$t('page.eventClasses.placeholder.race-length')"
                        ></v-text-field>
                      </template>

                      <v-card height="auto" width="340" style="padding: 2%" class="text-input-date">
                        <div>
                          <v-time-picker
                            v-if="menu['raceLength']"
                            v-model="raceLength"
                            :color="navigationBGColor"
                            :header-color="navigationBGColor"
                            format="24hr"
                            use-seconds
                            @click:second="$refs.raceLength.save(startTime)"
                          >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="$refs.raceLength.save(startTime)">
                            OK
                          </v-btn>
                          </v-time-picker>
                        </div>
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-row no-gutters>
                      <v-col sm="4">
                        <v-text-field
                          :v-model="backgroundColor"
                          type="color"
                          :label="$t('page.eventClasses.plate-background-color')"
                          outlined
                          dense
                          style="margin: 0 10px 0 0"
                        ></v-text-field>
                      </v-col>
                      <v-col sm="4">
                        <v-text-field
                          v-model="numberColor"
                          type="color"
                          :label="$t('page.eventClasses.place-number-color')"
                          outlined
                          dense
                          style="margin: 0 10px 0 0"
                        ></v-text-field>
                      </v-col>
                      <v-col sm="4" style="margin: 0 auto 0 0">
                        <v-text-field
                          v-model="stickerColor"
                          type="color"
                          :label="$t('page.eventClasses.helmet-sticker-color')"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="field-sm-c">
                  <v-col cols="10">
                    <v-select
                      v-model="stickerShape"
                      :label="$t('page.eventClasses.helmet-sticker-shape')"
                      :items="selectShape"
                      :placeholder="$t('page.eventClasses.select-shape.placeholder')"
                      outlined
                      dense
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                </v-row>

              </v-container>
            </v-form>
            <SGSNotificationError 
                v-if="snackbarError" :notificationMessage="msgError" :acept="$t('page.eventClasses.close-sn')"
                small @agree="agree" type="error"
            />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-subheader>{{ $t("page.eventClasses.msg-save-class") }}</v-subheader>
            <v-btn v-if="type" style="margin: 0 1rem 1rem auto" @click="closeDialog">{{
              $t("dashboard.menu.createRace.close_label")
            }}</v-btn>
            <v-btn v-if="type" style="margin: 0 1rem 1rem 0" @click="save">{{
              $t("page.eventClasses.save")
            }}</v-btn>
            <v-btn v-else style="margin: 0 1rem 1rem auto" @click="save">{{
              $t("page.eventClasses.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationError from "@/components/custom/notification/NotificationError.vue";

export default {
  mixins: [apiCalls],
  props: [ "type","idClass"],
  components: {
    SGSNotificationError
  },
  data() {
    return {
      return_create_race: false,
      valid: true,
      name: null,
      sort: null,
      rowLimit: null,
      reserved: null,
      group: null,
      startRow: null,
      startTime: null,
      raceLength: null,
      startTimeText: '',
      raceLengthText: '',
      backgroundColor: null,
      numberColor: null,
      stickerColor: null,
      stickerShape: null,
      itemsStickerShape: [],
      snackbarSuccess: false,
      snackbarError: false,
      msgSuccess: "",
      msgError: "",
      menu: {
        startTime: false,
        raceLength: false,
        backgroundColor: false
      }
    };
  },
  computed: {
    rules: function () {
      return {
        name: {
          idBackend: "cName",
          validate: {
            required: (value) =>
              !!value || this.$t("page.eventClasses.validations.null_cName"),
            valid: (value) => {
              const pattern = /^[A-Za-z0-9+-\s]+$/;
              return (
                pattern.test(value) ||
                this.$t("page.eventClasses.validations.invalid_cName")
              );
            },
          },
        },
        sort: {
          idBackend: "sortOrder",
          validate: {
            valid: (value) => {
              //const pattern = /^[0-9]*$/;
              value = Number(value)
              if( value === null || value.toString().length === 0 || (Number.isInteger(value) && value >= 0) )
                return true;

              return (
                /*!pattern.test(value) ||*/
                this.$t("page.eventClasses.validations.invalid_sortOrder")
              );
            },
          },
        },
        rowLimit: {
          idBackend: "rowLimit",
          validate: {
            valid: (value) => {
              const pattern = /^[0-9-,\s]+$/;
              return (
                value === undefined || value === null || value.toString().length === 0 || pattern.test(value) ||
                this.$t("page.eventClasses.validations.invalid_rowLimit")
              );
            },
          },
        },
        reserved: {
          idBackend: "reservedRows",
          validate: {
            valid: (value) => {
              const pattern = /^[A-Za-z0-9,\s]*$/;
              return (
                pattern.test(value) ||
                this.$t("page.eventClasses.validations.invalid_reservedRows")
              );
            },
          },
        },
        group: {
          idBackend: "classGroup",
          validate: {
            valid: (value) => {
              const pattern = /^[A-Za-z\s]*$/;
              return (
                pattern.test(value) ||
                this.$t("page.eventClasses.validations.invalid_classGroup")
              );
            },
          },
        },
        startRow: {
          idBackend: "startRow",
          validate: {
            valid: (value) => {
              //const pattern = /^[0-9]+{[.d]*}$/;
              value = Number(value);
              if(value === null || value.toString().length === 0 || (Number.isInteger(value) && value >= 0) )
                return true;
              return (
                /*pattern.test(value) ||*/
                this.$t("page.eventClasses.validations.invalid_startRow")
              );
            },
          },
        }
      };
    },
    selectShape: function () {
      return [
        this.$t("page.eventClasses.select-shape.square"),
        this.$t("page.eventClasses.select-shape.circle"),
      ];
    },
    titlePage: function () {
      const title =
        this.$route.name === "EditClasses" || this.type == 'edit'
          ? this.$t("page.eventClasses.edit-class")
          : this.$t("page.eventClasses.create-new-class");
      return title;
    },
  },
  methods: {
    agree()
    {
      this.snackbarError = false;
    },
    closeDialog(){
      this.$emit("closeDialog");
    },
    link() {

      //var path = "/racesCreate/" + this.$route.params.id;
      const name = "RacesCreate";
      if (this.$route.name !== name) {
        this.$router.push({
          name, params: this.$route.params
        });
      }
    },
    loadClass: async function () {
      var response = await this.api("get", "/api/v1/promoter/eventClass/getClass/" + this.$route.params.idClass);
      const { success } = response;
      if(success) {
        this.name =  response.message[0].name;
        this.sort = response.message[0].sortOrder;
        this.rowLimit =  response.message[0].rowLimit;
        this.reserved = response.message[0].reservedRows;
        this.group = response.message[0].classGroup;
        this.startRow = response.message[0].startRow;
        this.startTime = response.message[0].startTime !== null ? response.message[0].startTime.toString() : null;
        this.raceLength = response.message[0].raceLength !== null ? response.message[0].raceLength.toString() : null;
        this.backgroundColor = `#${response.message[0].plateBgColor}`;
        this.numberColor = `#${response.message[0].plateNumColor}`;
        this.stickerColor = `#${response.message[0].helmetStkColor}`;
        this.stickerShape = this.selectShape[ response.message[0].helmetStkShape - 1 ];
      }
      this.$refs.formClasses.resetValidation();
    },
    resetForm: function () {
      this.$refs.formClasses.reset()
    },
    reset: function () {
      this.name = "";
    },
    save: async function () {
     
      if (this.$refs.formClasses.validate()) {
        let idShape = this.selectShape.indexOf(this.stickerShape) + 1;
        let data = {
          id: this.$route.name === 'EditClasses' || this.type == 'edit' ? this.$route.params.idClass : null,
          cName: this.name, 
          name: this.name,
          eventId: this.$route.params.id, 
          plateBgColor: this.backgroundColor && this.backgroundColor.toString().substr(1), 
          plateNumColor: this.numberColor && this.numberColor.toString().substr(1), 
          helmetStkColor: this.stickerColor && this.stickerColor.toString().substr(1), 
          reservedRows: this.reserved, 
          rowLimit: this.rowLimit, 
          classGroup: this.group, 
          startTime: this.startTime && `${this.startTime}`, 
          raceLength: this.raceLength && `${this.raceLength}`, 
          helmetStkShape: idShape, 
          sortOrder: this.sort, 
          startRow: this.startRow, 
        };
        let method = "post";
        let url = "/api/v1/promoter/eventClass";
        if(this.$route.name === "EditClasses" || this.type == 'edit') {
          method = "put";
        }
        const response = await this.api( method, url, data );
        const { success, message } = response;
        if (success) {
          if(this.$route.name === 'CreateClasses')
            this.reset();
          this.snackbarSuccess = true;
          this.msgSuccess = this.$t("page.eventClasses.save-success");
        } else {
          let error = "";
          for (let i = 0; i < message.length; i++) {
            error += this.$t(`page.eventClasses.validations.${message[i]}`) + " ";
          }
          this.snackbarError = true;
          this.msgError = error;
        }
      }else{
        this.snackbarError = true;
        this.msgError = this.$t("page.eventClasses.validations.invalid_form");
         let element = "";
        for(var i = 11 ; i >= 0 ; i--){
          if(this.$refs.formClasses.inputs[i].hasError)
            element = document.getElementById(""+this.$refs.formClasses.inputs[i].id);
        }
        element.scrollIntoView({block: "end", behavior: "smooth"});
      }
      this.$emit("saveDate",this.snackbarSuccess);
    },
    saveTime: function () {
      const arrayHour = this.startTime.split(":");
      const hour = Number(arrayHour[0]) > 12 ? (Number(arrayHour[0]) - 12) : Number(arrayHour[0]);
      const type = Number(arrayHour[0]) > 11 ? 'PM' : 'AM';
      const hourString =  (hour > 0 && hour < 10) ? `0${hour}` : (hour === 0 ? '12' : hour);
      this.startTimeText = `${hourString}:${arrayHour[1]} ${type}`;
      //this.menu.startTime = false;
    },
    saveRaceLength: function () {
      const arrayHour = this.raceLength.split(":");
      const hour = Number(arrayHour[0]) > 12 ? (Number(arrayHour[0]) - 12) : Number(arrayHour[0]);
      const type = Number(arrayHour[0]) > 11 ? 'PM' : 'AM';
      const hourString =  (hour > 0 && hour < 10) ? `0${hour}` : (hour === 0 ? '12' : hour);
      this.raceLengthText = `${hourString}:${arrayHour[1]} ${type}`;
      //this.menu.raceLength = false;
    }
  },
  mounted() {
    if(this.$route.name === 'EditClasses' || this.type == 'edit'){
      if(this.type == 'edit')
        this.$route.params.idClass= this.idClass
      this.loadClass();
    }else
      this.resetForm();

    if(this.sort==null)
      this.sort = 99
  },

  created: function() {
    this.navigationBGColor = process.env.VUE_APP_HEADER_COLOR;
    if (typeof this.$route.query.createRace === "undefined") {
      this.return_create_race = false;
    } else {
      this.return_create_race = true;
    }
  }
};
</script>

<style>
.msg-info-class {
  text-align: left;
  font-size: smaller;
  margin: -16px 16px 0 16px;
}
.max-w-color {
  max-width: 56px;
}
.v-input__control .v-text-field__details {
  min-width: 300px;
  padding: 0 !important;
}
.not-card-title {
  margin: 20px 0 10px 0;
}
input[type="color"] {
  height: 32px;
}

@media only screen and (min-width: 913px) {
  .width-lg {
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media only screen and (max-width: 600px) {
  .subheader-sm-c {
    margin-bottom: -.5rem;
  }

  .field-sm-c .col-sm-3 {
    padding: 0;
  }

  .field-sm-c .col-sm-8 {
    padding: 0 12px;
  }

  .not-card-title {
    margin: 20px 0 10px 10px;
  }
}
</style>
